import React from 'react';

function FiltersOperator({ state, dispatch }) {
  const setFiltersOperator = (operator) => {
    dispatch({
      type: 'SET_FILTERS_OPERATOR',
      payload: operator
    })
  }

  if (!state.activeFilters.length) return null;

  return (
    <div
      className="filters-operator"
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          setFiltersOperator('AND');
        }}
        className={state.operator === 'AND' ? 'active' : ''}
      >
        AND
      </button>
      <button
        onClick={(e) => {
          e.preventDefault();
          setFiltersOperator('OR');
        }}
        className={state.operator === 'OR' ? 'active' : ''}
      >
        OR
      </button>
    </div>
  );
}

export default FiltersOperator;
